import CoursePaymentHistory from "../section/paymenthistorypage/CoursePaymentHistory";

export default function PaymentHistoryPage() {
    return (
        <CoursePaymentHistory />
    );
}
